import React from 'react'

import { Container, Space, Stack, Title } from '@mantine/core'

import { Loader } from '#components/Loader'

import { LoginSignupButtons } from './LoginSignupButtons'
import { OnboardingBanner, PromoBanner } from './OnboardingBanner'
import { OnboardingForm } from './OnboardingForm'
import { OnboardingInfo } from './OnboardingInfo'
import { OnboardingLinks, TermsOfUseLink } from './OnboardingLinks'
import { SubmitButton } from './OnboardingSubmitButton'

import styles from './OnboardingPage.module.scss'

export const OnboardingPage = ({
  children,
  title,
  loading,
}: {
  children: React.ReactNode
  title: string
  loading?: boolean
}) => {
  return (
    <div className={styles.onboardingPage}>
      <Loader visible={loading} fullScreen opacityDelay={1000} />
      <Stack align="center">
        <Title order={1} c="white" className={styles.onboardingPage_title}>
          {title}
        </Title>
        <Container className={styles.onboardingPage_contents}>
          {children}
          <Space h={30} />
        </Container>
      </Stack>
    </div>
  )
}

OnboardingPage.Buttons = LoginSignupButtons
OnboardingPage.Banner = OnboardingBanner
OnboardingPage.PromoBanner = PromoBanner
OnboardingPage.Form = OnboardingForm
OnboardingPage.Links = OnboardingLinks
OnboardingPage.TermsOfUseLink = TermsOfUseLink
OnboardingPage.Info = OnboardingInfo
OnboardingPage.SubmitButton = SubmitButton
